var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9091 4.69092H7.09082V19.3091H16.9091V4.69092Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.69089C6 4.0884 6.48842 3.59998 7.09092 3.59998H16.9092C17.5117 3.59998 18.0001 4.0884 18.0001 4.69089V19.3091C18.0001 19.9116 17.5117 20.4 16.9092 20.4H7.09092C6.48842 20.4 6 19.9116 6 19.3091V4.69089ZM8.18183 5.78181V18.2181H15.8182V5.78181H8.18183Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6363 5.99988H8.99993C8.69868 5.99988 8.45447 6.24409 8.45447 6.54534V8.18171C8.45447 8.48296 8.69868 8.72717 8.99993 8.72717H10.6363C10.9375 8.72717 11.1818 8.48296 11.1818 8.18171V6.54534C11.1818 6.24409 10.9375 5.99988 10.6363 5.99988Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6363 10.3635H8.99993C8.69868 10.3635 8.45447 10.6077 8.45447 10.909V12.5454C8.45447 12.8466 8.69868 13.0908 8.99993 13.0908H10.6363C10.9375 13.0908 11.1818 12.8466 11.1818 12.5454V10.909C11.1818 10.6077 10.9375 10.3635 10.6363 10.3635Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 5.99988H13.3636C13.0623 5.99988 12.8181 6.24409 12.8181 6.54534V8.18171C12.8181 8.48296 13.0623 8.72717 13.3636 8.72717H14.9999C15.3012 8.72717 15.5454 8.48296 15.5454 8.18171V6.54534C15.5454 6.24409 15.3012 5.99988 14.9999 5.99988Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 10.3635H13.3636C13.0623 10.3635 12.8181 10.6077 12.8181 10.909V12.5454C12.8181 12.8466 13.0623 13.0908 13.3636 13.0908H14.9999C15.3012 13.0908 15.5454 12.8466 15.5454 12.5454V10.909C15.5454 10.6077 15.3012 10.3635 14.9999 10.3635Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6727 16.1312H12.3273C13.0473 16.1312 13.6364 16.7032 13.6364 17.4024V19.3091H10.3636V17.4024C10.3636 16.7032 10.9527 16.1312 11.6727 16.1312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidBuilding);
export default __webpack_public_path__ + "static/media/solid-building.8a3f0e4c584917e2acc2d7db3be61fd6.svg";
export { ForwardRef as ReactComponent };